module.exports = "/wwwroot/img/collection_vehicle_search_result_page.png?ver=eb3d5fdb";